import { Action, Col, Row } from '@op/opds.opux';
import MoreLessWCAG from './../../components/common/MoreLessWCAG';
import AccessibilityInfo from './../../components/InfoSection/AccessibilityInfo';
import styles from './InfoSection.module.scss';
import LocalizedTextList from '../LocalizedTextList';
import i18n from 'i18n';

const InfoSection = ({
  hideAutomaticDecisionMakingInfo,
}: {
  hideAutomaticDecisionMakingInfo?: boolean;
}) => {
  return (
    <div className={styles.infosection} data-testid='infosection'>
      {!hideAutomaticDecisionMakingInfo && (
        <Row id='navigation-area-second-row'>
          <Col>
            <p
              className={styles.infoText}
              data-testid='decision-making-info-text'>
              {i18n.t('infoSection.decisionInfoText')}
            </p>
            <MoreLessWCAG
              messages={{
                more: i18n.t('infoSection.showMore'),
                less: i18n.t('infoSection.showLess'),
              }}
              screenReaderMessages={{
                more: i18n.t(
                  'moreLessScreenReaderMessages.more.automaticDecisionMaking'
                ),
                less: i18n.t(
                  'moreLessScreenReaderMessages.less.automaticDecisionMaking'
                ),
              }}
              className={styles.moreLess}
              data-testid='decision-info-more-less'>
              <div
                className={styles.infoText}
                data-testid='decision-info-text-more'>
                <LocalizedTextList
                  texts={
                    i18n.t('infoSection.decisionInfoTextMore', {
                      returnObjects: true,
                    }) as string[] | undefined
                  }
                />
              </div>
              <Action
                external
                inline
                href={i18n.t('infoSection.PERSONAL_DATA_PROTECTION_LINK')}
                className={styles.link}>
                {i18n.t('infoSection.readMoreAboutPersonalDataUse')}
              </Action>
            </MoreLessWCAG>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <AccessibilityInfo />
        </Col>
      </Row>
      <Row>
        <Col>
          <p className={styles.infoText} data-testid='tax-info-text'>
            {i18n.t('infoSection.taxInfoText')}
          </p>
          <MoreLessWCAG
            messages={{
              more: i18n.t('infoSection.showMore'),
              less: i18n.t('infoSection.showLess'),
            }}
            screenReaderMessages={{
              more: i18n.t('moreLessScreenReaderMessages.more.taxInfo'),
              less: i18n.t('moreLessScreenReaderMessages.less.taxInfo'),
            }}
            className={styles.moreLess}
            data-testid='tax-info-more-less'>
            <div className={styles.infoText} data-testid='tax-info-text-more'>
              <LocalizedTextList
                texts={
                  i18n.t('infoSection.taxInfoTextMore', {
                    returnObjects: true,
                  }) as string[] | undefined
                }
              />
            </div>
          </MoreLessWCAG>
        </Col>
      </Row>
    </div>
  );
};

export default InfoSection;
